import React, { useEffect, useState } from 'react'
import Layout from '../../../components/common/pageLayout'
import ChecklistForm from '../../../components/Production/Form/NewBuildingPreLaunchingCheckList'

import { v2_projects, v2_ships } from '../../../actions/v2/projectAndVessel';
import { v2_user_by_roles } from '../../../actions/v2/user';
import { v3_fetchNewBuildingPreLaunchingCheckListFields, v3_submitNewBuildingPreLaunchingCheckList } from '../../../actions/v3/productionForm';
import { toast } from 'react-toastify';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import constant from '../../../constant';
import Swal from 'sweetalert2';

const PreLaunchingChecklist = (props) => {
    const location = useLocation();

    const { data } = location.state || {};

    const [state, setState] = useState([
        {
            id: '',
            name: '',
            active: true,
            items: [
                { id: '', label: '', remarks: '', statusOfCompletion: '', completionDate: '', checkedBy: '', highPriority: false, active: true },
            ],
        },
    ]);

    const [commonDetails, setCommonDetails] = useState({
        project: { name: 'project', value: '', options: [], isRequired: true, error: '' },
        ship: { name: 'ship', value: '', options: [], isRequired: true, error: '' },
        date: { name: 'date', value: '', isRequired: false, error: '' },
        finalSubmit: { name: 'finalSubmit', value: '', isRequired: false, error: '' },
        siteManager: { name: 'siteManager', value: '', isRequired: false, error: '' },

    })

    const [showLoader, setShowLoader] = useState(false);
    const [users, setUsers] = useState([]);

    useEffect(() => {
        v2_projects().then((res) => {
            if (res.status) {
                setCommonDetails((prev) => ({
                    ...prev,
                    project: { ...prev.project, options: res.result },
                }));
            }
        });
        v2_user_by_roles().then((res) => {
            if (res.status) setUsers(res.result || []);
        });
    }, [])

    useEffect(() => {
        if (commonDetails.project.value) {
            v2_ships(null, commonDetails.project.value).then((res) => {
                if (res.status) {
                    setCommonDetails((prev) => ({
                        ...prev,
                        ship: { ...prev.ship, options: res.result },
                    }));
                }
            });
        }
        else {
            setCommonDetails((prev) => ({
                ...prev,
                ship: { ...prev.ship, options: [], value: '' },
            }));
        }
    }, [commonDetails.project.value])


    const handleChange = (sectionIndex, itemIndex, field, value) => {
        const updated = [...state];
        updated[sectionIndex].items[itemIndex][field] = value;
        setState(updated);
    };

    useEffect(() => {
        setShowLoader(true);
        let query = null;
        if (data) query = JSON.parse(atob(data));

        v3_fetchNewBuildingPreLaunchingCheckListFields(query?.PROJECT_ID, query?.SHIP_ID)
            .then((res) => {
                if (res.status) {
                    if (query) {

                        const sections = (res.result.sections || []).map(s => {
                            return {
                                ...s,
                                items: (s.items || []).filter(i => i.active).map(i => {

                                    return {
                                        ...i,
                                        statusOfCompletion: i.statusOfCompletion === 'Y' ? 'yes' : i.statusOfCompletion === 'N' ? 'no' : '',
                                        completionDate: i.completionDate || '',
                                        highPriority: Boolean(i.highPriority)

                                    };
                                })
                            };
                        });

                        // A server-side fetch failure still comes back as status:true with an
                        // error-shaped result, so read commonDetails defensively.
                        const details = res.result.commonDetails || {};

                        setCommonDetails((prev) => ({
                            ...prev,
                            project: { ...prev.project, value: details.PROJECT_ID },
                            ship: { ...prev.ship, value: details.SHIP_ID },
                            date: { ...prev.date, value: details.SUBMISSION_DATE },
                            finalSubmit: { ...prev.finalSubmit, value: Boolean(details.FINAL_SUBMITTED) },
                            siteManager: { ...prev.siteManager, value: details.SITE_MANAGER_NAME },

                        }))

                        setState(sections);
                    }
                    else {
                        const sections = (res.result.sections || []).filter(s => s.active).map(s => ({
                            ...s,
                            items: (s.items || []).filter(i => i.active).map(i => ({ ...i, remarks: '', statusOfCompletion: '', completionDate: '', checkedBy: '' }))
                        }));

                        setState(sections);
                    }
                } else {
                    toast.error(res.error);
                }
            })
            .catch(() => toast.error('Something went wrong while fetching.'))
            .finally(() => setShowLoader(false));
    }, []);

    const onSubmit = async () => {

        const isFinalSubmit = commonDetails.finalSubmit.value;
        let errorMessages = [];

        // Always validate project and ship
        if (!commonDetails.project.value) {
            errorMessages.push('Please select a Project.');
        }
        if (!commonDetails.ship.value) {
            errorMessages.push('Please select a Ship.');
        }
        if (!commonDetails.date.value) errorMessages.push('Please Select a date.');


        if (isFinalSubmit) {
            state.forEach((section) => {
                section.items.forEach((item) => {
                    if (!item.statusOfCompletion) {
                        errorMessages.push(`Section ${section.name}: Status is required.`);
                    }
                });
            });
        }

        // Show error alerts if any
        if (errorMessages.length > 0) {
            toast.error(errorMessages.join('\n'));
            return;
        }
        // If final submit is true, confirm before proceeding
        if (commonDetails.finalSubmit.value) {
            const confirmResult = await Swal.fire({
                title: 'Are you sure?',
                text: 'Do you want to submit the reports for Office Review?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, submit it',
                cancelButtonText: 'Cancel',
            });

            if (!confirmResult.isConfirmed) return;
        }

        // Prepare submission payload
        const payload = [];

        state.forEach((section) => {
            section.items.forEach((item) => {
                let model = {
                    ITEM_NAME: item.label,
                    ITEM_ID: item.id,
                    SECTION: section.name,
                    REMARK: item.remarks,
                    "IS_HIGH_PRIORITY": Number(item.highPriority),
                    STATUS_OF_COMPLETION: item.statusOfCompletion === 'yes' ? 'Y' : item.statusOfCompletion === 'no' ? 'N' : '',
                    COMPLETION_DATE: item.completionDate || '',
                    CHECKED_BY: item.checkedBy,
                }
                if (item.entryId) {
                    model.ID = item.entryId
                }
                payload.push(model);
            });
        });

        // Include common details in the payload if needed
        const submissionData = {
            // This is the Create screen, so a previous draft for the selected
            // project/hull must be rebuilt from the current configuration.
            replaceConfigurationSnapshot: !data,
            commonDetails: {
                project: commonDetails.project.value,
                ship: commonDetails.ship.value,
                date: commonDetails.date.value,
                finalSubmit: isFinalSubmit,
            },
            checklistItems: payload,
        };

        console.log('Submitting payload:', submissionData);

        // Call your submit API here with submissionData
        v3_submitNewBuildingPreLaunchingCheckList(submissionData).then((res) => {
            if (res.status) {
                toast.success(res.result.message)
                props.history.push(constant.Authedcomponent.submittedNewBuildingPreLaunchingCheckList.url)
                // Handle successful submission
            } else {
                toast.error(res.error)

                // Handle submission error
            }
        });
    };



    return (
        <Layout
            title={'New Building Pre-Launching Check List'}

        >
            <div className="row">
                <div className="col-lg-12">
                    <div className="card">
                        <div className="card-body">
                            <div className="checklist-title-bx">
                                <div className="row">
                                    <div className="col-md-8">
                                        <div className="text-left">
                                            <h4>New Building Pre Launching Check List</h4>
                                            <p>Following to be checked as a preparation for launching</p>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <table className="table-bottom-sig table-top-sig">
                                            <tbody>
                                                <tr className="bottom-sig-tr2-box">
                                                    <td className="input-td">
                                                        <p className="s2">Date</p>
                                                    </td>
                                                    <td>
                                                        <p className="s1">
                                                            <input
                                                                type="date"
                                                                className="form-control"
                                                                value={commonDetails.date.value}
                                                                onChange={(e) =>
                                                                    setCommonDetails((prev) => ({
                                                                        ...prev,
                                                                        date: { ...prev.date, value: e.target.value },
                                                                    }))
                                                                }
                                                            />
                                                        </p>
                                                    </td>
                                                </tr>
                                                <tr className="bottom-sig-tr2-box">
                                                    <td className="input-td">
                                                        <p className="s2">Project</p>
                                                    </td>
                                                    <td>
                                                        <p className="s1">
                                                            <select
                                                                className="form-control"
                                                                value={commonDetails.project.value}
                                                                disabled={data ? true : false}
                                                                onChange={(e) =>
                                                                    setCommonDetails((prev) => ({
                                                                        ...prev,
                                                                        project: { ...prev.project, value: e.target.value },
                                                                    }))
                                                                }
                                                            >

                                                                <option value={''}>Select Project</option>
                                                                {commonDetails.project.options.map((item) => {
                                                                    return (<option value={item.ID}>{item.PROJECT_CODE} - {item.PROJECT_NAME}</option>)
                                                                })}
                                                            </select>
                                                        </p>

                                                    </td>
                                                </tr>
                                                <tr className="bottom-sig-tr2-box">
                                                    <td className="input-td">
                                                        <p className="s2">Hull</p>
                                                    </td>
                                                    <td>

                                                        <p className="s1">
                                                            <select
                                                                className="form-control"
                                                                disabled={data ? true : false}
                                                                value={commonDetails.ship.value}
                                                                onChange={(e) =>
                                                                    setCommonDetails((prev) => ({
                                                                        ...prev,
                                                                        ship: { ...prev.ship, value: e.target.value },
                                                                    }))
                                                                }
                                                            >

                                                                <option value={''}>Select Hull</option>
                                                                {commonDetails.ship.options.map((item) => {
                                                                    return (<option value={item.ID}>{item.HULL_NUMBER} - {item.SHIP_NAME}</option>)
                                                                })}
                                                            </select>
                                                        </p>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div className="row" id={1}>
                                <div className="col-md-12">
                                    <ChecklistForm
                                        state={state}
                                        onChange={handleChange}
                                        users={users}
                                        siteManager={commonDetails.siteManager.value}

                                        isFinalSubmitting={commonDetails.finalSubmit.value}
                                        setIsFinalSubmitting={() => setCommonDetails((prev) => ({
                                            ...prev,
                                            finalSubmit: { ...prev.finalSubmit, value: !commonDetails.finalSubmit.value },
                                        }))}
                                        onSubmit={() => onSubmit()}

                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    )
}

export default PreLaunchingChecklist
